import type { FullDemandSignalDTO } from 'api';

export const buildDemandSignalLabel = (signal: FullDemandSignalDTO): string =>
  `ID:${signal.id}; ${signal.buyer ? `Buyer:${signal.buyer.name}` : `Lead:${signal.buyer_lead?.name}`}; Grade:${signal.material_grade.name} Material Spec: ${signal.material_spec.title}`;
